/**
 * Invitation Management Action Hooks
 *
 * These hooks provide high-level invitation management actions
 * that convert Stytch responses to our domain types.
 */
import { useCallback } from 'react';
import { useStytchWrappers } from './stytch-hooks';
/**
 * Hook to send an invitation via magic link email
 */
export function useSendInvitation() {
    const { sendInvitation } = useStytchWrappers();
    return useCallback(async (data) => {
        const result = await sendInvitation({
            email_address: data.emailAddress,
            invite_redirect_url: data.inviteRedirectUrl,
            invite_template_id: data.inviteTemplateId,
            name: data.name,
            roles: data.roles,
            untrusted_metadata: data.untrustedMetadata,
            locale: data.locale,
        });
        if (result.success) {
            return {
                success: true,
                invitation: result.invitation,
                data: result.data,
            };
        }
        else {
            return {
                success: false,
                error: result.error,
                data: result.data,
            };
        }
    }, [sendInvitation]);
}
